module.exports = __webpack_public_path__ + "img/stand_boluo_expect_cut.0d0ebe38.png";